document.documentElement.classList.add('js');

const privacyBannerCountries = new Set([
  'AT', 'BE', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
  'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
]);

let privacyBannerFallbackStarted = false;

function hasSavedPrivacyChoice() {
  try {
    if (window.localStorage.getItem('nimas_privacy_choice') === '1') {
      return true;
    }
  } catch (error) {
    // Continue with Shopify's consent API when storage is unavailable.
  }

  const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

  if (
    customerPrivacy &&
    typeof customerPrivacy.getTrackingConsent === 'function'
  ) {
    const consent = customerPrivacy.getTrackingConsent();
    return consent === 'yes' || consent === 'no';
  }

  return false;
}

function rememberPrivacyChoice() {
  try {
    window.localStorage.setItem('nimas_privacy_choice', '1');
  } catch (error) {
    // Shopify still stores the consent when local storage is unavailable.
  }
}

function showPrivacyBannerIfRequired() {
  if (
    privacyBannerFallbackStarted ||
    !privacyBannerCountries.has(window.Shopify && window.Shopify.country) ||
    hasSavedPrivacyChoice() ||
    !window.privacyBanner ||
    typeof window.privacyBanner.showBanner !== 'function'
  ) {
    return;
  }

  privacyBannerFallbackStarted = true;

  window.setTimeout(function () {
    if (document.getElementById('shopify-pc__banner')) return;

    window.privacyBanner.showBanner().catch(function (error) {
      console.warn('Unable to display the cookie banner.', error);
    });
  }, 800);
}

function updateCookiePreferencesButtons() {
  const canShowPreferences =
    window.privacyBanner &&
    typeof window.privacyBanner.showPreferences === 'function';

  document.querySelectorAll('[data-cookie-preferences]').forEach(function (button) {
    button.hidden = !canShowPreferences;
  });

  if (canShowPreferences) {
    showPrivacyBannerIfRequired();
  }

  return canShowPreferences;
}

document.addEventListener('DOMContentLoaded', function () {
  if (updateCookiePreferencesButtons()) return;

  let attempts = 0;
  const privacyBannerTimer = window.setInterval(function () {
    attempts += 1;

    if (updateCookiePreferencesButtons() || attempts >= 20) {
      window.clearInterval(privacyBannerTimer);
    }
  }, 500);
});

document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;

  document.querySelectorAll('.language-switcher__details[open]').forEach(function (details) {
    if (!details.contains(event.target)) {
      details.removeAttribute('open');
    }
  });

  const privacyChoiceButton = event.target.closest(
    '#shopify-pc__banner__btn-accept, ' +
    '#shopify-pc__banner__btn-decline, ' +
    '[id^="shopify-pc__prefs"][id$="save"], ' +
    '[id^="shopify-pc__prefs"][id$="accept"], ' +
    '[id^="shopify-pc__prefs"][id$="decline"]'
  );

  if (privacyChoiceButton) {
    rememberPrivacyChoice();
  }

  const thumb = event.target.closest('[data-gallery-thumb]');

  if (thumb) {
    const gallery = thumb.closest('[data-product-gallery]');

    if (gallery) {
      const index = thumb.getAttribute('data-gallery-thumb');

      gallery.querySelectorAll('[data-gallery-image]').forEach(function (image) {
        const isActive = image.getAttribute('data-gallery-image') === index;
        image.classList.toggle('is-active', isActive);
        image.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
        const isActive = button.getAttribute('data-gallery-thumb') === index;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }
  }

  const cookiePreferencesButton = event.target.closest('[data-cookie-preferences]');

  if (
    cookiePreferencesButton &&
    window.privacyBanner &&
    typeof window.privacyBanner.showPreferences === 'function'
  ) {
    window.privacyBanner.showPreferences().catch(function (error) {
      console.warn('Unable to open cookie preferences.', error);
    });
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.language-switcher__details[open]').forEach(function (details) {
    details.removeAttribute('open');
  });
});

function initHeroCarousels() {
  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    if (carousel.dataset.heroCarouselReady === 'true') return;

    const track = carousel.querySelector('[data-hero-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
    const previousButton = carousel.querySelector('[data-hero-prev]');
    const nextButton = carousel.querySelector('[data-hero-next]');

    if (!track || slides.length < 1) return;

    carousel.dataset.heroCarouselReady = 'true';

    let currentIndex = 0;
    let autoplayTimer = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchPointerId = null;
    let suppressNextClick = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canAutoplay =
      carousel.dataset.heroAutoplay === 'true' &&
      !reducedMotion &&
      slides.length > 1;
    const interval = Math.max(Number(carousel.dataset.heroInterval) || 6000, 4000);

    function loadHeroSlideMedia(slide) {
      if (!slide || slide.dataset.heroMediaLoaded === 'true') return;

      slide.querySelectorAll('source[data-srcset]').forEach(function (source) {
        source.srcset = source.dataset.srcset.trim();
        source.removeAttribute('data-srcset');
      });

      slide.querySelectorAll('img[data-hero-deferred-image]').forEach(function (image) {
        if (image.dataset.srcset) {
          image.srcset = image.dataset.srcset.trim();
          image.removeAttribute('data-srcset');
        }

        if (image.dataset.src) {
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
        }

        image.removeAttribute('data-hero-deferred-image');
      });

      slide.dataset.heroMediaLoaded = 'true';
    }

    function setSlideFocusability(slide, isActive) {
      slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
        if (isActive) {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', '-1');
        }
      });
    }

    function setActiveSlide(nextIndex) {
      currentIndex = (nextIndex + slides.length) % slides.length;
      loadHeroSlideMedia(slides[currentIndex]);
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';

      slides.forEach(function (slide, index) {
        const isActive = index === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        setSlideFocusability(slide, isActive);
      });

      dots.forEach(function (dot, index) {
        const isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        dot.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      if (!canAutoplay || autoplayTimer) return;
      autoplayTimer = window.setInterval(function () {
        setActiveSlide(currentIndex + 1);
      }, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        setActiveSlide(Number(dot.dataset.heroDot) || 0);
        startAutoplay();
      });

      dot.addEventListener('keydown', function (event) {
        let nextIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = currentIndex + 1;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = currentIndex - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = dots.length - 1;
        }

        if (nextIndex === null) return;

        event.preventDefault();
        stopAutoplay();
        setActiveSlide(nextIndex);
        dots[currentIndex].focus();
        startAutoplay();
      });
    });

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        stopAutoplay();
        setActiveSlide(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        stopAutoplay();
        setActiveSlide(currentIndex + 1);
        startAutoplay();
      });
    }

    carousel.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' || !event.isPrimary || slides.length < 2) return;

      touchStartX = event.clientX;
      touchStartY = event.clientY;
      touchPointerId = event.pointerId;
    });

    carousel.addEventListener('pointerup', function (event) {
      if (touchPointerId !== event.pointerId) return;

      const deltaX = event.clientX - touchStartX;
      const deltaY = event.clientY - touchStartY;
      touchPointerId = null;

      if (Math.abs(deltaX) < 28 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;

      suppressNextClick = true;
      stopAutoplay();
      setActiveSlide(currentIndex + (deltaX < 0 ? 1 : -1));
      startAutoplay();

      window.setTimeout(function () {
        suppressNextClick = false;
      }, 220);
    });

    carousel.addEventListener('pointercancel', function (event) {
      if (touchPointerId === event.pointerId) touchPointerId = null;
    });

    carousel.addEventListener(
      'click',
      function (event) {
        if (!suppressNextClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    carousel.addEventListener('pointerenter', stopAutoplay);
    carousel.addEventListener('pointerleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    loadHeroSlideMedia(slides[0]);
    setActiveSlide(0);
    startAutoplay();
  });
}

document.addEventListener('DOMContentLoaded', initHeroCarousels);
document.addEventListener('shopify:section:load', initHeroCarousels);
